import { type InferInsertModel, type InferSelectModel, relations } from 'drizzle-orm';
import {
  boolean,
  doublePrecision,
  pgTable,
  text,
  timestamp,
  uuid,
} from 'drizzle-orm/pg-core';
import { fabricTypePrintTypes } from './compatibility';

export const printTypes = pgTable('print_types', {
  id: uuid('id')
    .primaryKey()
    .$defaultFn(() => Bun.randomUUIDv7()),
  description: text('description').notNull(),
  price: doublePrecision('price').notNull(),
  isActive: boolean('is_active').default(true),
  createdAt: timestamp('created_at')
    .notNull()
    .$defaultFn(() => new Date()),
  updatedAt: timestamp('updated_at')
    .$onUpdate(() => new Date())
    .notNull(),
});

export const printTypesRelations = relations(printTypes, ({ many }) => ({
  fabricTypePrintTypes: many(fabricTypePrintTypes),
}));

export type PrintType = InferSelectModel<typeof printTypes>;
export type CreatePrintTypeInput = InferInsertModel<typeof printTypes>;
export type UpdatePrintTypeInput = Partial<CreatePrintTypeInput>;
